module.exports = __webpack_public_path__ + "assets/img/15b.092cf234.jpg";